import createActionTypes from './createActionTypes';

export const namespace = 'PRODUCTS';

export const types = createActionTypes(namespace, ['RESET']);

export const resetProducts = (resetState) => ({
  type: types.RESET,
  payload: { resetState },
});
